import { Link } from "gatsby"
import * as React from "react"

interface Props {
  items: Array<any>
}

const Item = ({ item, icon }: any) => {
  return (
    <article className="column is-one-third mb-2 px-1">
      <Link className={`guide-link has-borders`} to={item.path}>
        <span className="columns my-0">
          <span className="column py-0">
            <span className="is-size-7 has-text-30">
              {item.type === "getting-started" && "30mn"}
              {item.type === "topical" && "1h"}
              {item.type === "tutorial" && "3h"}
            </span>
          </span>
        </span>
        <h2>{item.title}</h2>
        <div>{item.description}</div>
        <div className="categories pt-2">
          {item.category.map((category: string, index: number) => (
            <span key={`category-${index}`} className="tag is-spring">{category}</span>
          ))}
        </div>
      </Link>
    </article>
  )
}

const List = ({ items }: Props) => {
  return (
    <div className="columns is-multiline columns-list mx-1">
      {items?.map((item: any, index) => (
        <Item key={`item-${index}`} item={item} />
      ))}
    </div>
  )
}

export default List
